module.exports = __webpack_public_path__ + "static/media/guinea-pig.e41b7695.svg";